import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { useOrganizationSettings } from '../hooks/useOrganizationSettings';
import { ActivityPulseSection } from './ActivityPulseSection';
import { AppVersionSection } from './AppVersionSection';
import { OrganizationOverview } from './OrganizationOverview';
import { OrganizationTabSkeleton } from './OrganizationTabSkeleton';

export function OrganizationTab() {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const { organization, isLoading } = useOrganizationSettings();

    if (isLoading) {
        return <OrganizationTabSkeleton />;
    }

    return (
        <div className="flex flex-col gap-8 pt-14 pb-24">
            <h3 className="text-sm font-medium text-white-100">
                {t('organization.details')}
            </h3>
            <div className="flex flex-col gap-12 pl-2">
                <div className="flex flex-col gap-1">
                    <span className="text-sm text-grey-200  tracking-wide">
                        {t('organization.name')}
                    </span>
                    <span className="text-sm text-white-100">
                        {organization?.name ?? '-'}
                    </span>
                </div>

                <div className="flex flex-col gap-1 ">
                    <span className="text-sm text-grey-200  tracking-wide">
                        {t('organization.logo')}
                    </span>
                    {organization?.logoUrl ? (
                        <img
                            src={organization.logoUrl}
                            alt="Organization logo"
                            className="h-14 w-14 rounded"
                        />
                    ) : (
                        <span className="text-sm text-grey-400">
                            {t('organization.noLogo')}
                        </span>
                    )}
                </div>
            </div>

            <div className="border-t border-grey-600" />

            <OrganizationOverview />

            <div className="border-t border-grey-600" />

            <ActivityPulseSection />

            <div className="border-t border-grey-600" />

            <AppVersionSection />
        </div>
    );
}
